"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotUpdateTable = void 0;
const core_1 = require("@material-ui/core");
const core_2 = require("@material-ui/core");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const text_field_1 = require("client/components/material/text-field");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const columns = [
    {
        id: "lotNumber",
        label: "Lot#"
    },
    {
        id: "originalCount",
        label: "Original Count"
    },
    {
        id: "newCount",
        label: "New Count"
    }
];
const styles = () => core_1.createStyles({
    root: {
        minWidth: 0,
        width: "100px"
    },
    listRoot: {
        gridColumn: "span 2",
        width: "400px",
        margin: "0 auto",
        padding: "1rem"
    }
});
let LotUpdateTableUnstyled = class LotUpdateTableUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.handleNewCountChange = (inventoryLot) => (event, value) => {
            inventoryLot.quantity = Number(value) >= 0 ? Number(value) : 0;
        };
        this.renderRow = (inventoryLot, index) => {
            const { classes } = this.props;
            const inventoryLotOriginal = this.props.inventoryLotsOriginal[inventoryLot.id];
            return (React.createElement(list_item_1.MaterialListItem, { key: index },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: inventoryLotOriginal.lotNumber }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: inventoryLotOriginal.quantity }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(text_field_1.MaterialTextField, { value: inventoryLot.quantity, className: classes.root, type: "number", numType: "integer", label: "New Count", onChange: this.handleNewCountChange(inventoryLot) }) })));
        };
    }
    componentWillMount() {
        console.log("this.props", this.props);
    }
    render() {
        const { inventoryLots, classes } = this.props;
        return (React.createElement("div", { className: classes.listRoot },
            React.createElement(list_1.MaterialList, { columns: columns, rows: inventoryLots ? Object.values(inventoryLots) : [], renderRow: this.renderRow })));
    }
};
LotUpdateTableUnstyled = __decorate([
    mobx_react_1.observer
], LotUpdateTableUnstyled);
exports.LotUpdateTable = core_2.withStyles(styles)(LotUpdateTableUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-detail/components/edit-cycle-count/components/edit-cycle-count-review/components/lot-update-table/lot-update-table.tsx
// module id = 4105
// module chunks = 0